import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import React, { Fragment } from 'react'
import { useRef } from 'react';
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import estilos from '../../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { Store } from 'react-notifications-component';
import { getElementoSeccionByIdArea } from '../../../../../redux/DucksUnidadInspeccion/ElementoSeccionDuck';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function ProcesosYEquipo(props) {

    const dispatch = useDispatch();

    const tipoequipo = useSelector(store => store.ElementoSeccion.ElementoSeccion);
    const procesos = useSelector(store => store.Procesos.Proceso);

    const otros = props.otros;

    const [equipoArea, setEquipo] = React.useState([]);
    const [procesosArea, setProcesosArea] = React.useState([]);

    const [initialValues, setInitialValues] = React.useState({
        equipoArea: equipoArea,
        procesosArea: procesosArea,
        largo: 0,
        ancho: 0,
        area: 0
    })

    const [informacionFormikModal, setInformacionFormikModal] = React.useState(
        {
            tipo: '',
            cantidad: '',
            capacidad: '',
            descripcion: '',
            condicion: '',
            largo: '',
            ancho: '',
            area: ''
        }
    );

    const [openModalNuevoEquipo, setOpenModalNuevoEquipo] = React.useState(false);

    const [editarEquipo, setEditarEquipo] = React.useState(true);

    const [seccionesAreaEnvasado, setSeccionesAreaEnvasado] = React.useState([]);

    useEffect(() => {
        console.log(props.informe)

        if (props.tipo == 2) {
            dispatch(getElementoSeccionByIdArea(6))
        } else {
            dispatch(getElementoSeccionByIdArea(props.idseccion))
        }

        if (props.tipo == 2) {
            if (props.idseccion == 30) {
                setEquipo([])
            } else {
                setEquipo(props.informe.fi_25_anexo[0].fi_25_anexo_equipo_historial)               
            }
        } else {
            setEquipo(props.informe.fi_25_anexo[0].fi_25_anexo_equipo_historial.filter(e => e.elemento.elementosdeseccion[0].idseccion == props.idseccion))
        }

        setProcesosArea(props.informe.fi_25_anexo[0].fi_25_anexo_procesos.filter(p => p.procesos.idseccion == props.idseccion))

    }, [props.idseccion])

    useEffect(() => {
        console.log(props.informe)
        let sup;
        if (props.idseccion == 30) {
            sup = props.informe.fi_25_anexo[0].superficie[1];

            setInitialValues({
                equipoArea: equipoArea,
                procesosArea: procesosArea,
                largo: sup.largo != null ? sup[0].largo : 0,
                ancho: sup.ancho != null ? sup[0].ancho : 0,
                area: sup.area != null ? sup[0].area : 0
            })

        } else {
            sup = props.informe.fi_25_anexo[0].superficie.filter(s => s.idseccion == props.idseccion);

            setInitialValues({
                equipoArea: equipoArea,
                procesosArea: procesosArea,
                largo: sup[0].largo != null ? sup[0].largo : 0,
                ancho: sup[0].ancho != null ? sup[0].ancho : 0,
                area: sup[0].area != null ? sup[0].area : 0
            })
        }

    }, [equipoArea, props.idseccion])


    const handleModificar = () => {
        setEditarEquipo(!editarEquipo);
    }

    const handleOpenModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(true);
    }
    const handleCloseModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(false);
    }

    const handleNuevoEquipo = (valores) => {

        let equipoSeleccionado = tipoequipo.filter((t) => valores.tipo == t.idelemento)

        setEquipo([...equipoArea, {
            cantidad: valores.cantidad,
            capacidad: valores.capacidad,
            condicion: valores.condicion,
            descripcion: valores.descripcion,
            elemento: {
                idelemento: valores.tipo,
                tipoOtros: valores.tipoOtros,
                nombreelemento: equipoSeleccionado[0].elemento.nombreelemento
            },
            //idanexocliente: 1,
            //iddataelemntocliente: 1,
            //idseccion: 1,
            otro: null
        }])

        handleCloseModalNuevoEquipo();
    }

    const handleEliminarEquipo = (elemento) => {
        let nuevoEquipo = equipoArea.filter((equipo) => equipo !== elemento);
        setEquipo(nuevoEquipo);
    }

    const modalNuevoEquipo = () => {
        return (
            <div>
                <Modal
                    open={openModalNuevoEquipo}
                    onClose={handleCloseModalNuevoEquipo}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Nuevo Equipo
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={informacionFormikModal}
                                onSubmit={(valores) => {
                                    handleNuevoEquipo(valores)
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className='table-responsive'>
                                            <table className='table table-striped table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th>Tipo</th>
                                                        <th>Cantidad</th>
                                                        <th>Capacidad (ton)</th>
                                                        <th>Descripción y/o características</th>
                                                        <th width="120">Condición</th>
                                                        {
                                                            //<th>Largo (m)</th>
                                                            //<th>Ancho (m)</th>
                                                            //<th>Área (m²)</th>
                                                        }
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="tipo"
                                                                name="tipo"
                                                                className="form-select"
                                                                multiple={false}
                                                                required
                                                            >
                                                                <option defaultValue>Seleccione Tipo de Equipo</option>
                                                                {tipoequipo.map((t, index) => (
                                                                    <option key={index} value={t.idelemento}>{t.elemento.nombreelemento}</option>
                                                                ))}
                                                            </Field>

                                                            {
                                                                props.values.tipo === "4" ?
                                                                    <div>
                                                                        <br />
                                                                        <label htmlFor='tipoOtros'>Tipo de equipo:</label>
                                                                        <Field
                                                                            type="text"
                                                                            id="tipoOtros"
                                                                            name="tipoOtros"
                                                                            className="form-control form-control-sm"
                                                                        />
                                                                    </div>
                                                                    : <div></div>
                                                            }
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name="cantidad" placeholder="Cantidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name="capacidad" placeholder="Capacidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name="descripcion" placeholder="Descripción" required /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name="condicion"
                                                                className="form-select"
                                                                multiple={false}
                                                                required

                                                            >
                                                                <option defaultValue>Seleccione Condicion</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button type='submit' className="btn btn-success">GUARDAR</button>
                                            <br />
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>

            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validate={(valores) => {

                }}

                onSubmit={(valores) => {


                }}
            >
                {({ values }) => (
                    <Form>
                        {/* } <div className='row'>
                            <label className={`${estilos.labelUI_title} mb-2`}>PESADO DE AGAVE</label>
                        </div>
                        */}
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <label className={`${estilos.labelUI} mb-2`}>Superficie:</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-3 mb-3">
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="largo">Largo (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" required />
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="ancho">Ancho (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" required />
                            </div>

                            <div className="col-md-2 mb-3">
                                <label htmlFor="area">Área (m²)</label>
                                <Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={values.largo * values.ancho} required />
                            </div>
                        </div>
                        <hr />
                        <div className='table-responsive'>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Cantidad</th>
                                        <th>Capacidad (ton)</th>
                                        <th>Descripción y/o características</th>
                                        <th width="120">Condición</th>
                                        {//<th>Largo <br /> (m)</th>
                                        }
                                        {//<th>Ancho (m)</th>
                                        }
                                        {//<th>Área (m²)</th>
                                        }
                                        <th>Acciones</th>
                                        <th>Validar</th>
                                    </tr>
                                </thead>
                                <FieldArray
                                    name='equipoArea'
                                    render={arrayHelpers => (
                                        <tbody>
                                            {equipoArea &&
                                                equipoArea.map((equipo, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                {equipo.elemento.nombreelemento}
                                                                <h6>{equipo.elemento.tipoOtros}</h6>
                                                            </td>
                                                            <td><Field type="text" className="form-control form-control-sm" id="cantidad" name={`equipoArea.${index}.cantidad`} placeholder="Cantidad" required disabled={false} /></td>
                                                            <td><Field type="text" className="form-control form-control-sm" id="capacidad" name={`equipoArea.${index}.capacidad`} placeholder="Capacidad" required disabled={false} /></td>
                                                            <td><Field type="text" className="form-control form-control-sm" id="descripcion" name={`equipoArea.${index}.descripcion`} placeholder="Descripción" required disabled={false} /></td>
                                                            <td>
                                                                <Field
                                                                    component="select"
                                                                    id="condicion"
                                                                    name={`equipoArea.${index}.condicion`}
                                                                    className="form-select"
                                                                    multiple={false}
                                                                    disabled={false}
                                                                    required
                                                                >
                                                                    <option defaultValue>Seleccione Condicion</option>
                                                                    <option value={"Buena"}>Buena</option>
                                                                    <option value={"Regular"}>Regular</option>
                                                                    <option value={"Mala"}>Mala</option>
                                                                </Field>
                                                            </td>

                                                            <td><button type="button" className='btn btn-warning btn-sm' onClick={() => handleModificar()}>Modificar</button> <hr /> <button type="button" className='btn btn-danger btn-sm' onClick={() => handleEliminarEquipo(equipo)}>Eliminar</button></td>
                                                            <td><Field className="form-check-input" type="checkbox" name={`equipoArea.${index}.validar`} id="validar" /></td>
                                                        </tr>
                                                    )
                                                })}
                                        </tbody>
                                    )}
                                />
                            </table>
                        </div>
                        <br />
                        <div style={{ textAlign: "center" }}>
                            <button type="button" className={`btn ${estilos.botonCircular}`} onClick={handleOpenModalNuevoEquipo}>+ </button> Añadir nuevo equipo
                        </div>
                        <br />
                        <div className='row'>
                            <label className={`${estilos.labelUI} mb-2`}>MÉTODO</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-4 mb-3">
                                <label htmlFor="">PROCESO</label>
                            </div>
                            <div className="col-md-8 mb-3">
                                <label htmlFor="">DESCRIPCIÓN</label>
                            </div>
                        </div>
                        {
                            props.tipo === 2 ?
                                otros != true ?
                                    <FieldArray
                                        name='procesosArea'
                                        render={arrayHelpers => (
                                            <div>
                                                {procesosArea.map((p, index) => (
                                                    <div key={index}>
                                                        <div className='row'>
                                                            <div className="col-md-4 mb-3">
                                                                <label htmlFor={`proceso.${index}`}>{p.procesos.descripcion}</label>
                                                            </div>
                                                            <div className="col-md-8 mb-3">
                                                                <Field type="text" className="form-control form-control-sm" id={`procesosArea.${index}`} name={`procesosArea.${index}.comentarios`} placeholder={p.procesos.descripcion} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    />
                                    :
                                    <div></div>
                                :
                                <div></div>

                        }
                        {
                            <div className="row mb-5">
                               <div className="col ">
                                   <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit'>GUARDAR</button>
                               </div>
                            
                            </div>
                        }
                    </Form>
                )}
            </Formik>
            <div>
                {modalNuevoEquipo()}
            </div>
        </Fragment>
    );
};


export default withRouter(ProcesosYEquipo)
